<template>
  <div class="program-cate" v-if="cateList && cateList.length>0">
      <div v-for="(item ,index) in cateList" :key="index" class="program-cate-item" :class="{'active':curIndex==index}" @mouseenter="mouseChange(index,item.id)" @mouseleave="changeOut" @click="clickChange(item.id)" >
        <span class="iconfont" :class="item.icon"></span>
        <div class="item-txt">
          <p v-text="item.showname"></p>
          <em v-text="item.eName" :class="{'smallfont':item.eName.length >12}"></em>
        </div>
      </div>
  </div>
</template>

<script>
import colums from '../colums/colums.js'

export default {
  name: 'jmkcate',
  props: {
    curIndex: Number
  },
  data(){
    return{
      // cateList:colums.jmkcate
    }
  },
  computed:{
    cateList(){
      let list = JSON.parse(JSON.stringify(colums.jmkcate))
      // if(this.$route.path=='/' || this.$route.path =='/index' || this.$route.path =='/index/'){
      //   return list.slice(0,5)
      // }
      return list
    }
  },
  methods:{

    //鼠标滑过
    mouseChange(index,id){
      if(index==this.curIndex){
        return;
      };
      this.$emit("mouseChange",{
        id:id,
        index:index
      })
    },
    changeOut(){
      // console.log("滑出")
    },

    // 点击切换
    clickChange(id){
      this.$emit("clickChange",{
        id:id
      })
    }

  }
}
</script>
<style scoped >


</style>